// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fy","advertDetailHeaderLocation__value":"c-m_fz"};